// extracted by mini-css-extract-plugin
export default {"loader":"acotrs_loaderEAJGT","icon":"acotrs_iconUFrGe"};